<template>
  <div class="row mt-4">
    <!-- Panel de resumen y gráfico -->
    <div class="col-lg-6">
      <div class="card p-3">
        <h5 class="mb-3">Informe de Hornos</h5>

        <!-- Filtros -->
        <div class="row mb-3">
          <div class="col-md-6">
            <label for="fecha_inicio" class="form-label">Fecha inicio</label>
            <input
              id="fecha_inicio"
              type="date"
              class="form-control"
              v-model="fecha_inicio"
            />
          </div>
          <div class="col-md-6">
            <label for="fecha_fin" class="form-label">Fecha fin</label>
            <input
              id="fecha_fin"
              type="date"
              class="form-control"
              v-model="fecha_fin"
            />
          </div>
        </div>

        <!-- Gráfico -->
        <canvas id="hornosChart"></canvas>

        <!-- Resumen -->
        <ul class="mt-3">
          <li>
            <strong>Total de Hornos:</strong> {{ resumen.total_hornos }}
          </li>
          <li>
            <strong>Rango:</strong>
            {{ resumen.rango.desde || "—" }} → {{ resumen.rango.hasta || "—" }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Tabla Detallada -->
    <div class="col-lg-6">
      <div class="card p-3">
        <h5 class="mb-3">Detalle de Cargas por Horno</h5>

        <div class="table-responsive">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>ID</th>
                <th>Horno</th>
                <th>Consecutivo</th>
                <th>Quemada</th>
                <th>Carbon Total (kg)</th>
                <th>Cargas</th>
                <th>Prom. Absorción Agua</th>
                <th>Fin</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in totales" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.horno }}</td>
                <td>{{ item.consecutivo }}</td>
                <td>{{ item.burn_number }}</td>
                <td>{{ item.total_carbon.toFixed(2) }}</td>
                <td>{{ item.cargas }}</td>
                <td>{{ item.promedio_absorcion_agua.toFixed(2) }}</td>
                <td>{{ formatDate(item.fecha_finalizacion) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Tabla Detalle de Cargas -->
    <div class="col-12 mt-4">
      <div class="card p-3">
        <h5 class="mb-3">Detalle de quemas </h5>

        <div class="table-responsive">
          <table class="table table-bordered table-sm">
            <thead>
              <tr>
                <th>Horno</th>
                <th>Patio Carbón</th>
                <th>Cantidad (kg)</th>
                <th>Absorción Agua</th>
                <th>Absorción Agua 2</th>
                <th>Inicio</th>
                <th>Fin</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(horno, index) in detalle"
                :key="'h' + horno.id + '-' + index"
              >
                <template v-for="(f, i) in horno.furnaces" :key="i">
                  <tr>
                    <td>{{ horno.horno }}</td>
                    <td>{{ f.patio_carbon }}</td>
                    <td>{{ f.carbon_quantity }}</td>
                    <td>{{ f.water_absorption }}</td>
                    <td>{{ f.water_absorption_2 }}</td>
                    <td>{{ formatDate(f.fecha_inicio) }}</td>
                    <td>{{ formatDate(f.fecha_fin) }}</td>
                  </tr>
                </template>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Chart,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
Chart.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default {
  name: "InformeHornos",
  data() {
    const hoy = new Date();
    const hace15 = new Date();
    hace15.setDate(hoy.getDate() - 15);

    const formatDate = (d) => {
      const y = d.getFullYear();
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${y}-${m}-${day}`;
    };

    return {
      fecha_inicio: formatDate(hace15),
      fecha_fin: formatDate(hoy),
      resumen: { total_hornos: 0, rango: { desde: null, hasta: null } },
      totales: [],
      detalle: [],
      chartInstance: null,
    };
  },
  watch: {
    fecha_inicio() {
      this.fetchInforme();
    },
    fecha_fin() {
      this.fetchInforme();
    },
  },
  methods: {
    async fetchInforme() {
      try {
        const params = {
          fecha_inicio: this.fecha_inicio,
          fecha_fin: this.fecha_fin,
        };

        const res = await this.$store.dispatch("analitycs/getInformeHornos", params);
        const data = res.data;

        this.resumen = {
          total_hornos: data.total_hornos || 0,
          rango: data.rango || {},
        };
        this.totales = data.totales || [];
        this.detalle = data.detalle || [];

        this.renderChart();
      } catch (error) {
        console.error("Error cargando informe de hornos:", error);
      }
    },

    renderChart() {
      if (this.chartInstance) this.chartInstance.destroy();

      const ctx = document.getElementById("hornosChart");

      const labels = this.totales.map((t) => t.horno || `Horno #${t.id}`);
      const dataCarbon = this.totales.map((t) => t.total_carbon);

      this.chartInstance = new Chart(ctx, {
        type: "bar",
        data: {
          labels,
          datasets: [
            {
              label: "Carbon Total (kg)",
              data: dataCarbon,
              backgroundColor: "#36A2EB",
            },
          ],
        },
        options: {
          responsive: true,
          plugins: { legend: { position: "bottom" } },
          scales: {
            y: { beginAtZero: true },
          },
        },
      });
    },

    formatDate(date) {
      if (!date) return "";
      return new Date(date).toLocaleDateString("es-ES");
    },
  },
  mounted() {
    this.fetchInforme();
  },
};
</script>

<style scoped>
.table {
  font-size: 0.85rem;
}
.table-bordered td,
.table-bordered th {
  border: 1px solid #ddd;
}
</style>
